import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const DraggableItem = ({
	children,
	id,
	index,
	moveItem,
	targetType,
	dragEnd
}) => {
	const ref = useRef(null);
	const [{ handlerId }, drop] = useDrop({
		accept: targetType,
		collect(monitor) {
			return {
				handlerId: monitor.getHandlerId()
			};
		},
		hover(item, monitor) {
			if (!ref.current) {
				return;
			}
			const dragIndex = item.index;
			const hoverIndex = index;
			if (dragIndex === hoverIndex) {
				return;
			}
			const hoverBoundingRect = ref.current?.getBoundingClientRect();
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const clientOffset = monitor.getClientOffset();
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;
			if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
				return;
			}
			if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
				return;
			}
			moveItem(dragIndex, hoverIndex);

			// eslint-disable-next-line no-param-reassign
			item.index = hoverIndex;
		}
	});

	const [{ isDragging }, drag] = useDrag({
		type: targetType,
		item: () => {
			return { index, id };
		},
		end: (item) => {
			dragEnd(item.index, item.id);
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging()
		})
	});

	const style = {
		opacity: isDragging ? 0 : 1,
		/* Note: Transform fixes a chrome issue: https://github.com/react-dnd/react-dnd/issues/832. The issue still persists in Safari. */
		transform: "translate3d(0, 0, 0)"
	};

	drag(drop(ref));

	return (
		<div ref={ref} style={style} data-handler-id={handlerId}>
			{children}
		</div>
	);
};

export default DraggableItem;
